/*
 * fn: parseArchidektDeck
 *
 * Given an array of Gallery Groups, parses an archidekt decklist for the archidekt scraper to use
 *
 */
import { type GalleryGroupType } from '@/defs/gallery'
import { type Dict } from '@/defs/misc'

type ArchidektDeckType = Dict<{ cardcount: string; cardname: string }[]>

export const parseArchidektDeck = (groups: GalleryGroupType[]) =>
  groups.reduce<ArchidektDeckType>((acc, g) => {
    acc[g.label] = g.recs.map((r) => ({
      cardcount: String(r.count || 1),
      cardname: r.name,
    }))
    return acc
  }, {})
